import React, { Fragment } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core/styles";
import { styles } from "./styles";
import withRoot from "../../withRoot";
var QRCode = require("qrcode.react");

const useStyles = makeStyles({
  qrCode: {
    height: "80%",
    display: "flex",
    "& canvas": {
      margin: "auto"
    },
    marginTop: "8px",
    marginBottom: "8px"
  }
});

interface IHelpProps {
  name: any;
  value: any;
}

const QRCodes: React.FC<IHelpProps> = ({ value, name }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <div>
        Please use the following QR-Code for <b>{name}</b>
        <br />
        <b>Link:</b>{" "}
        <a target="_blank" href={value}>
          {value}
        </a>
      </div>
      <div className={classes.qrCode}>
        <QRCode
          value={value}
          size={120}
          bgColor={"#ffffff"}
          fgColor={"#000000"}
          level={"H"}
          includeMargin={false}
          renderAs={"canvas"}
          // imageSettings={{
          // 	src: "https://storage-bhavins.s3.amazonaws.com/heart.jpg",
          // 	x: null,
          // 	y: null,
          // 	height: 24,
          // 	width: 24,
          // 	excavate: true,
          // }}
        />
      </div>
    </Fragment>
  );
};

export default withRoot(withStyles(styles)(QRCodes));
